<template>
    <form-row title="Phone Number" :label_align_top="true">
        <div class="flex flex-col lg:flex-row items-start gap-4 w-full">
            <input-text class="w-full lg:w-2/5 flex-none" name="phone" type="tel" v-model="phone" />
            <team-message-consent v-if="showTeamMessageConsent" channel="sms" :number="phone" :value="!!broker.team_sms_consent_at" />
        </div>
    </form-row>
</template>

<script>
import TeamMessageConsent from './team-message-consent.vue';
export default {
    components: { TeamMessageConsent },
    props: {
        showTeamMessageConsent: { type: Boolean, default: false },
        settings: { default: () => ({}) },
        broker: { default: () => ({}) },
    },
    data() { return { phone: this.settings.phone || '' }; },
}
</script>
